import { AxiosResponse } from "axios"

// 指定范围随机整数
export function randomNumber(start: number, end: number): number {
    return Math.floor(Math.random() * (end - start + 1) + start)
}

// 从数组随机取一个元素
// eslint-disable-next-line
export function getRandomFromArr(arr: Array<any>): any {
    return arr[Math.floor((Math.random() * arr.length))]
}

// 一个字符串是否以某一个字符串开头?
export function isStartWith(str: string, start: string): boolean {
    return str.indexOf(start) == 0
}

// 判断得到的response是否成功执行了业务
export function AssertGoodResponse(res: AxiosResponse): void {
    const { status, data: { msg,code } } = res
    if (status != 200 || code != 0) {
        throw new Error(msg)
    }
}